import Vue from 'vue'
// import CategoryList from './components/CategoryList.vue'
// import CreateProduct from './components/CreateProduct.vue'
import ExpandIcon from './components/ExpandIcon.vue';
import AddToCart from './components/AddToCart.vue';
import Cart from './components/Cart.vue';
// import ProductSpecificationTable from './components/ProductSpecificationTable.vue';

// Vue.component('category-list', CategoryList)
// Vue.component('create-product', CreateProduct)
Vue.component('expand-icon', ExpandIcon);
Vue.component('add-to-cart', AddToCart);
Vue.component('cart-page', Cart);
// Vue.component('product-specification-table', ProductSpecificationTable);

const vm = new Vue({
  el: '#app'
});